import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

class ErrorMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { modal: true };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    render() {
        const { className, title, text } = this.props;
        const { modal } = this.state;

        return (
            <Modal isOpen={modal} toggle={this.toggle} className={className}>
                <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
                <ModalBody>
                    {text}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggle}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default ErrorMessage;




// WEBPACK FOOTER //
// ./src/components/ui/ErrorMessage.js